import { render, staticRenderFns } from "./ServerSkeleton.vue?vue&type=template&id=5c6964e1&scoped=true&"
import script from "./ServerSkeleton.vue?vue&type=script&lang=js&"
export * from "./ServerSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6964e1",
  null
  
)

export default component.exports